module.exports = __webpack_public_path__ + "img/arrow_full_down_white.950d2adb.svg";